<template>
  <div id="list-demo">
    <div class="widget-container">
      <DxList
        :data-source="dataSource"
        :height="400"
        :show-selection-controls="true"
        selection-mode="multiple"
        select-all-mode="page"
        :search-enabled="true"
        search-mode="contains"
        search-expr="text"
        :ref="dxListRefKey"
        @selection-changed="selectionChanged"
      >
        <template #item="{ data }">
          <div>
            <div>{{ data.text }}</div>
          </div>
        </template>
      </DxList>
      <vs-button
        @click="addCampaigns"
        class="float-right px-4 w-full md:w-auto mt-6"
        >{{$t("Advertiser.AddCampaigns")}}</vs-button
      >
    </div>
  </div>
</template>
<script>

import DxSelectBox from 'devextreme-vue/select-box'
import DxList from 'devextreme-vue/list'
import ArrayStore from 'devextreme/data/array_store'

const dxListRefKey = "select-unmapped-campaigns"

export default {
  components: {
    DxSelectBox,
    DxList
  },
  data () {
    return {
      selectedRowKeys: [],
      dxListRefKey
    }
  },
  props: {
    showPopup: Boolean,
    idAdvertiser: Number
  },
  methods: {
    addCampaigns () {
      this.$vs.loading()
      const payload = {
        id: this.idAdvertiser,
        campaignIds: this.selectedRowKeys
      }
      this.$store
        .dispatch(
          'campaignManagement/addCampaignsToAdvertiser',
          payload
        )
        .then(() => {
          this.$vs.loading.close()
          this.$emit('update:showPopup', false)
        })
        .catch((err) => {
          console.error(err)
          this.$vs.loading.close()
        })
    },
    selectionChanged (e) {
      this.selectedRowKeys = this.selectedRowKeys.concat(e.addedItems.map(a => a.id))
      this.selectedRowKeys = this.selectedRowKeys.filter((el) => !e.removedItems.map(a => a.id).includes(el))
    }
  },
  computed: {
    dataSource () {
      const campaigns = this.$store.state.campaignManagement.unmappedCampaigns.map((item) => {
        return { id: item.id, text: item.name }
      })
      return new ArrayStore({
        key: 'id',
        data: campaigns
      })
    }
  }
}

</script>
<style>
.selected-data {
  margin-top: 20px;
  padding: 20px;
  background-color: rgba(191, 191, 191, 0.15);
}

.selected-data .caption {
  font-weight: bold;
  font-size: 115%;
}

.options .caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 10px;
}

.option > span {
  width: 124px;
  display: inline-block;
}

.option > .dx-widget {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  max-width: 350px;
}
</style>
